<app-pcbread-crumb [data]="'Buy,BuyPreInvoice'"></app-pcbread-crumb>

<div
  id="AddCard"
  class="card card-body p-2 animate__animated animate__backInDown"
  *ngIf="level == 1"
>
  <app-pctable-action [data]="action" (parentAction)="parentAction($event)">
  </app-pctable-action>

  <div class="row p-1 mb-3">
    <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
      <label for="companyName" class="form-label m-0"
        >{{ "Company" | translate }}:</label
      >
      <div class="validation-alert-sale-buy" id="CompanyName">
        <p>{{ backendJson.companyIdMessage }}</p>
      </div>
      <app-drop-down
          [dropDownData]="companyList"
          [addUrl]="'DrugDistributor'"
          [defaultValue]="backendJson.companyId"
          [isValid]="
            backendJson.companyIdMessage == '' ||
            backendJson.companyIdMessage == null
          "
          [buttonClass]="'Focusable'"
          (ngModelValueChange)="changeCompany($event)"
        ></app-drop-down>
      
    </div>
    <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
      <div class="m-0 p-0">
        <label for="Seller" class="form-label">
          {{ "seller" | translate }}:
        </label>
      </div>
      <div class="validation-alert-sale-buy" id="visitor">
        <p>{{ backendJson.sellerIdMessage }}</p>
      </div>
      <app-drop-down
          [relationId]="backendJson.companyId"
          [relationName]="'drugDistributorsId'"
          [defaultValue]="backendJson.sellerId"
          [dropDownData]="sellerList"
          [fieldName]="['firstName', 'lastName']"
          [addUrl]="'Seller'"
          [isDisable]="backendJson.companyId == null"
          [buttonClass]="'Focusable'"
          (ngModelValueChange)="backendJson.sellerId = $event.id"
        ></app-drop-down>
    </div>
    <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
      <label for="factorDate" class="form-label m-0"
        >{{ "preInvoiceDate" | translate }}:</label
      >
      <div class="validation-alert-sale-buy">
        <p>{{ backendJson.preInvoiceDateMessage }}</p>
      </div>
      <div class="datepicker-box">
        <input
          id="factorDate"
          type="text"
          class="form-control Focusable"
          autocomplete="off"
          [ngClass]="{
            'is-invalid':
              backendJson.preInvoiceDateMessage != '' &&
              backendJson.preInvoiceDateMessage != null
          }"
          appSelectOnFocus
          [ngModel]="backendJson.preInvoiceDate | dataType : '' : false"
          [ngModelOptions]="{ standalone: true }"
          placeholder="YYYY/MM/DD"
          (ngModelChange)="factorTypeDate()"
        />
        <button
          [ngbPopover]="popoverDatapickerfactorDate"
          [autoClose]="'outside'"
          #datePicker="ngbPopover"
        >
          <i class="far fa-calendar-alt"></i>
        </button>
      </div>
      <ng-template #popoverDatapickerfactorDate>
        <app-data-picker
          [(childProp)]="backendJson.preInvoiceDate"
          (changeVariableMonth)="changeMonth($event)"
        ></app-data-picker>
      </ng-template>
    </div>
    <div class="col-12 col-lg-3 col-md-6 top-input-box mt-3">
      <label for="RecivedDate" class="form-label m-0"
        >{{ "receiveDate" | translate }}:</label
      >
      <div class="validation-alert-sale-buy">
        <p>{{ backendJson.receiveDateMessage }}</p>
      </div>
      <div class="datepicker-box">
        <input
          type="text"
          class="form-control Focusable"
          autocomplete="off"
          [ngClass]="{
            'is-invalid':
              backendJson.receiveDateMessage != '' &&
              backendJson.receiveDateMessage != null
          }"
          id="RecivedDate"
          appSelectOnFocus
          [ngModel]="backendJson.receiveDate | dataType : '' : false"
          [ngModelOptions]="{ standalone: true }"
          placeholder="YYYY/MM/DD"
          (ngModelChange)="deliveryTypeDate()"
        />
        <button
          [ngbPopover]="popoverDatapickerreceiveDate"
          [autoClose]="'outside'"
          #datePicker="ngbPopover"
        >
          <i class="far fa-calendar-alt"></i>
        </button>
      </div>
      <ng-template #popoverDatapickerreceiveDate>
        <app-data-picker
          [(childProp)]="backendJson.receiveDate"
          (changeVariableMonth)="changeMonth($event)"
        ></app-data-picker>
      </ng-template>
    </div>

    <div class="col-12 top-input-box mt-3">
      <label for="description" class="form-label m-0"
        >{{ "description" | translate }}:</label
      >
      <textarea
        id="description"
        type="text"
        class="form-control Focusable"
        placeholder="{{ 'description' | translate }}"
        [(ngModel)]="backendJson.description"
      >
      </textarea>
    </div>
  </div>

  <app-pctable
    #ShowTable
    [data]="data"
    [inlineEdit]="true"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>
  <div class="add-box">
    <form [formGroup]="drugSearchForm">
      <input
        id="drugBrandName"
        type="text"
        autocomplete="off"
        appSelectOnFocus
        formControlName="drugBrandName"
        class="form-control Focusable iner-Focusable search-input-box"
        placeholder="{{ 'searchPreInvoice' | translate }}"
        [(ngModel)]="editableItem.drugName"
        (keyup.escape)="modalIsOpen = false"
      />
    </form>
    <app-search-box
      [data]="searchData"
      [fields]="searchFields"
      [urlName]="'columnsArray_PreInvoiceSearch'"
      [paging]="searchPaging"
      [modalIsOpen]="modalIsOpen"
      [addButton]="true"
        (parentAction)="parentSearchAction($event)"
    ></app-search-box>
  </div>
  <div class="row p-1 mt-3">
    <div class="col-12">
      <hr />
    </div>
    <div class="col-12 d-flex justify-content-between">
      <button
        type="button"
        id="save-button"
        class="btn btn-primary Focusable iner-Focusable"
        (click)="submitForm()"
      >
        <i class="far fa-save"></i>
        {{ "Save" | translate }}
      </button>
      <button
        type="button"
        id="clear-button"
        class="btn btn-light ms-2 Focusable iner-Focusable"
        (click)="clearForm()"
      >
        <i class="fas fa-eraser"></i>
        {{ "Clear" | translate }}
      </button>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<div
  id="listCard"
  class="card p-2 animate__animated animate__backInDown"
  *ngIf="level == 2"
>
  <app-pctable-action
    [data]="actionList"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable [data]="listData" (parentAction)="parentAction($event)">
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  [inputModel]="modalConfirm"
  (childEvent)="parentAction($event)"
></app-pcconfrim-modal>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>
